import { format } from 'date-fns';

import { StandardCard } from 'src/app/components/Elements/Card/CardWithInnerTitle/styles';
import { SectionWithTitle } from 'src/app/components/Elements/SectionWithTitle';
import { Typography } from 'src/app/components/Elements/Typography';
import { PrescriptionDates, PrescriptionDatesContainer } from 'src/app/components/Models/Medication/styles';
import type { HomePrescriptionItem } from 'src/app/types';

interface CurrentPrescriptionSectionProps {
  prescriptionDetails: HomePrescriptionItem;
}

export const CurrentPrescriptionSection = ({ prescriptionDetails }: CurrentPrescriptionSectionProps) => {
  const { prescribedDate, expirationDate } = prescriptionDetails;
  return (
    <SectionWithTitle sectionTitle="Current Prescription">
      <StandardCard>
        <PrescriptionDatesContainer>
          <PrescriptionDates>
            <Typography variant="overline" color="capsuleGray50" marginBottom={'s3'}>
              Prescribed
            </Typography>
            <Typography variant="body">{format(Date.parse(prescribedDate!), 'MM/dd/yyyy')}</Typography>
          </PrescriptionDates>
          <PrescriptionDates>
            <Typography variant="overline" color="capsuleGray50" marginBottom={'s3'}>
              Prescription Expires
            </Typography>
            <Typography variant="body">{format(Date.parse(expirationDate!), 'MM/dd/yyyy')}</Typography>
          </PrescriptionDates>
        </PrescriptionDatesContainer>
      </StandardCard>
    </SectionWithTitle>
  );
};
